import { useQuery } from '@tanstack/react-query';
import { DocsRequests } from 'src/requests/docs';
import { queryRetry } from 'src/utils/react-query';

export const useDocsTrashQuery = ({
  q,
  sort,
}: {
  q?: string;
  sort?: 'asc' | 'desc';
} = {}) => {
  const { data: trashDocs, isLoading: isTrashDocsLoading } = useQuery(
    ['docsTrash', q, sort],
    () => DocsRequests.getTrashDocs({ q, sort }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchInterval: 1000 * 60 * 5,
      retry: queryRetry,
    },
  );

  return {
    trashDocs,
    isTrashDocsLoading,
  };
};
